import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useTheme } from 'styled-components'

import {
  gift_card_interest_event,
  unlock_membership_event
} from 'gtm/pushEvents'

import {
  Box,
  breakpoints,
  Button,
  Container,
  Header,
  Headline,
  P
} from 'ui/acro'
import { useWindowResize } from 'hooks'

const videoPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    src: PropTypes.string,
    srcType: PropTypes.string
  })
)

const Hero = ({ videos, title, body, cta }) => {
  const { spacing } = useTheme()
  const player = document.getElementById('hero-video')
  const [selectedVideos, setSelectedVideos] = useState()
  const [size, setSize] = useState()
  const { width } = useWindowResize()

  const disableRightClick = (e) => e.preventDefault()

  // Listen for window resize and set our size accordingly. Resizing triggers source change and reload for videos.
  useEffect(() => {
    setSize(width < breakpoints[1] ? 'mobile' : 'desktop')
  }, [width])

  // On size change, swap out video source, capture current time, reload player, and start again at currentTime.
  useEffect(() => {
    setSelectedVideos(videos[size])

    if (player) {
      const currentTime = player.currentTime
      player.load()
      player.currentTime = currentTime
    }
  }, [size])

  return (
    <Box position='relative'>
      <video
        autoPlay
        loop
        muted
        playsInline
        onContextMenu={disableRightClick}
        preload='auto'
        width='100%'
        height='100%'
        id='hero-video'
        style={{ display: 'block' }}
        alt={videos.alt}
      >
        {selectedVideos &&
          selectedVideos.map(({ src, srcType }, idx) => (
            <source src={src} type={srcType} key={idx} />
          ))}
        <P>Your browser does not support the video tag.</P>
      </video>

      <Container
        position={['relative', null, 'absolute']}
        top='0'
        width='100%'
        height='100%'
        pt={['17px', null, '0px']}
        bg={['', null, 'rgba(0, 0, 0, 0.4)']}
        centerProps={{
          justifyContent: 'center',
          textAlign: 'center'
        }}
      >
        <Headline mb={['7px', '15px']} color={['primary', null, 'white']}>
          {title}
        </Headline>
        <Header mb={['15px', '38px']} color={['grey6', null, 'white']}>
          {body}
        </Header>
        <Button
          as='a'
          href='/surveys/onboarding'
          className='unstyled'
          alignSelf={['stretch', null, 'center']}
          variant={['primary', null, 'primary-inverted']}
          id={'home-hero-button'}
          aria-label={cta}
          onClick={() => unlock_membership_event('homepage_banner')}
        >
          {cta}
        </Button>
        <P
          as='a'
          href='/gift?utm_source=so_hero'
          className='unstyled'
          borderBottom='1px solid white'
          color={['primary', null, 'base']}
          mt={spacing.small}
          mx='auto'
          onClick={() => gift_card_interest_event('so_hero')}
        >
          Send a Gift Card
        </P>
      </Container>
    </Box>
  )
}

Hero.propTypes = {
  videos: PropTypes.shape({
    desktop: videoPropTypes,
    mobile: videoPropTypes
  }),
  title: PropTypes.string,
  body: PropTypes.string,
  cta: PropTypes.string
}

export default Hero
